import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, Flex, Space } from 'antd';
import { PATH } from '@/v1/utils/constants';
import { CloseRoundedIcon, WarningIcon } from '@/v1/components/icons';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/commons/utils/atoms';

export function PlanBillingNotice() {
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();
  const userInfo = useAtomValue(userInfoAtom);

  useEffect(() => {
    setDismissed(false);
  }, [location.pathname]);

  const visible =
    !dismissed &&
    (!!userInfo?.renewal_invoice_url ||
      !!userInfo?.additional_conversation_invoice_url) &&
    location.pathname !== PATH.PLAN_AND_BILLING;

  if (!visible) return null;

  return (
    <div
      className="fixed left-1/2 top-4 z-50 max-w-[449px] -translate-x-1/2"
      style={{ fontFamily: 'Noto Sans JP' }}
    >
      <Flex
        align="center"
        className="h-[56px] gap-2 rounded-[16px] border border-[#E5E5EA] px-4! py-3! bg-white shadow-[0px_4px_12px_rgba(0,0,0,0.08)]"
      >
        <WarningIcon className="shrink-0" />
        <Space
          className="min-w-0 flex-1 text-sm font-medium text-[#333333]"
          size={4}
        >
          <span>お支払い方法の確認が必要です。</span>
          <Link
            to={PATH.PLAN_AND_BILLING}
            className="text-[#AD59F6]! font-normal leading-[160%] tracking-0 hover:underline!"
          >
            詳しくはこちら
          </Link>
        </Space>
        <Button
          type="text"
          shape="circle"
          size="small"
          className="shrink-0 text-[#A5A4AA] hover:text-black"
          onClick={() => setDismissed(true)}
        >
          <CloseRoundedIcon />
        </Button>
      </Flex>
    </div>
  );
}
